"use client"

import { Card, Col, Form, Row, Skeleton } from "antd"
import { useIsDesktop } from "@/hooks/app/useIsDesktop"
import { useTranslation } from "react-i18next"
import SearchingFlightsSkeleton from "@/components/flight/FormSearch/desktop/SearchingFlights.skeleton"

const SearchingVendorDesktopSkeleton = () => {
  const isDesktop = useIsDesktop()
  const { t } = useTranslation()

  if (!isDesktop) {
    return <></>
  }

  return (
    <Form style={{ zIndex: 1 }}>
      <Row justify="center" className="home__searching skeleton">
        <Col span={24}>
          <div className="home__searching-hero-strip">
            <div className="home__searching-content home__searching-content--search">
              <div className="home__searching--search-bridge">
                <Row className="home__searching--form-row">
                  <Col span={24} className="home__searching--form-overlap">
                    <div className="home__searching--tabs-bar" aria-hidden>
                      {[t("common.flight"), t("common.hotel"), t("common.tour"), t("common.esim"), "Visa"].map((label) => (
                        <div key={label} className="home__searching--tab">
                          <Skeleton.Button active size="small" style={{ width: "2rem", minWidth: "2rem" }} />
                          <Skeleton.Input active size="small" style={{ width: "7rem", minWidth: "7rem" }} />
                        </div>
                      ))}
                    </div>

                    <Card size="small" variant="borderless" className="home__searching--form-panel">
                      <SearchingFlightsSkeleton layout="hero" />
                    </Card>
                  </Col>
                </Row>

                {/*
                  Skeleton của khối tagline — dùng CHÍNH class .home__searching--tagline
                  (variant flights, tab mặc định) để chiều cao khớp hệt content thật,
                  tránh layout shift đẩy phần bên dưới nhảy xuống khi load xong.
                */}
                <div
                  className="home__searching--tagline home__searching--tagline--flights"
                  aria-hidden
                >
                  <div className="home__searching--tagline-lead">
                    <span className="home__searching--tagline-icon">
                      <Skeleton.Avatar active shape="square" size={22} />
                    </span>
                    <div className="home__searching--tagline-heading">
                      <Skeleton.Input active size="small" style={{ width: "14rem", minWidth: "14rem", height: "1.5rem" }} />
                      <Skeleton.Input active size="small" style={{ width: "18rem", minWidth: "18rem", height: "1.2rem" }} />
                    </div>
                  </div>

                  <div className="home__searching--tagline-features">
                    {[1, 2, 3].map((item) => (
                      <div key={item} className="home__searching--tagline-feature">
                        <span className="home__searching--tagline-feature-icon">
                          <Skeleton.Avatar active shape="square" size={18} />
                        </span>
                        <div className="home__searching--tagline-feature-text">
                          <Skeleton.Input active size="small" style={{ width: "8rem", minWidth: "8rem", height: "1.25rem" }} />
                          <Skeleton.Input active size="small" style={{ width: "10rem", minWidth: "10rem", height: "1.15rem" }} />
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </Form>
  )
}

export default SearchingVendorDesktopSkeleton
